import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const Availability = lazy(() => import('@pages/Availability'));

// Component that sets the page title and renders the page

// Route Component
const AvailabilityPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('availability-page-title')}>
        <Availability />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  AvailabilityPage,
};
